export default __webpack_public_path__ + "static/media/agency-logo.1865f510.jpg";